import React, { useState } from 'react'
import { TokenIconPath } from 'src/constants/Paths'
import 'src/assets/components/TokenIcon.css'

function getTokenIconURL(token: string, fileType: string = 'svg') {
  return TokenIconPath.replace(':token_name', token.replace(" ", "%20")).replace(':file_type', fileType)
}

const tokenNameMap: {
  [index: string]: string
} = {
}

export interface TokenIconIconProps {
  token?: string
  className?: string
}

const TokenIcon: React.FunctionComponent<TokenIconIconProps> = (
  props: TokenIconIconProps,
) => {
  const { token, className } = props
  const [imageSrcError, setImageSrcError] = useState(false);
  const [imageSrcIndex, setImageSrcIndex] = useState(0);

  let symbolToFetch = ""
  if (token) {
    const tokenName = token.charAt(0).toUpperCase() + token.slice(1)
    symbolToFetch = tokenNameMap[tokenName] ?? (tokenName === 'Ibc' ? 'IBC' : tokenName)
  }

  const imageSrcArray = symbolToFetch
    ? [
      getTokenIconURL(symbolToFetch, 'svg'),
      getTokenIconURL(symbolToFetch, 'png'),
    ] : []

  const handleImgSrcError = () => {
    if (imageSrcIndex < imageSrcArray.length - 1) {
      setImageSrcIndex(imageSrcIndex + 1);
    } else {
      setImageSrcError(true);
    }
  }

  let defaultIcon: React.ReactNode = (
    <div className={`token-placeholder ${className}`}>
      ?
    </div>
  )

  return !imageSrcError && symbolToFetch ? (
    <img className={className} src={imageSrcArray[imageSrcIndex]} onError={handleImgSrcError} alt={symbolToFetch} />
  ) : <div>{defaultIcon}</div>
}

export default TokenIcon
